(ns hai.web-app.feature-flag.ui
  "The feature-flag rows on the profile page. Each flag decides whether a group
   of nav items appears — see `show-menu-item?` in [[hai.web-app.layout]] — so
   the copy talks about the menu rather than about flags."
  (:require
   [hai.ui.components :as c]
   [hai.ui.rf-sugar :refer [<s >e]]
   [hai.ui.tokens :as t]
   [lambdaisland.ornament :as o]))

(def section-title "Control what features you want to use")

(def lead-text
  (str "Your Humble shows only what you use. Switch a feature off and it "
       "leaves your menu. Switch it on and it comes back."))

;; ---------------------------------------------------------------------------
;; Rows
;; ---------------------------------------------------------------------------

(o/defstyled flag-list :div
  :flex :flex-col
  {:gap "10px"})

(o/defstyled flag-lead :p
  {:font-size "14px"
   :color t/--colour-dim
   :margin "0"
   :max-width "60ch"})

(o/defstyled flag-row :div
  :flex :flex-col
  {:gap "6px"
   :padding "14px 16px"
   :border "1px solid var(--colour-rock)"
   :border-radius "10px"}
  ;; The switch sits on the title's line rather than centred against the whole
  ;; row, so it stays put as descriptions wrap to two lines.
  [:.flag-head
   :flex :items-center
   {:gap "8px"}]
  [:.flag-name
   {:font-size "15px" :font-weight "700"
    :color t/--text-secondary}]
  [:.flag-switch {:margin-left "auto"}]
  [:.flag-description
   {:font-size "14px"
    :color t/--colour-dim
    :max-width "60ch"}])

(o/defstyled advanced-label :h3
  {:font-size "14px" :font-weight "700"
   :color t/--text-secondary
   :margin "6px 0 0"})

(defn- flag-row-view
  [{:keys [flag-name description checked? on-change]}]
  [flag-row
   [:div.flag-head
    [:span.flag-name flag-name]
    [:span.flag-switch
     [c/Switch {:checked checked? :on-checked-change on-change}]]]
   [:span.flag-description description]])

;; ---------------------------------------------------------------------------
;; Panel
;; ---------------------------------------------------------------------------

(defn feature-flags-panel []
  [flag-list
   [flag-lead lead-text]
   [flag-row-view
    {:flag-name   "Beta features"
     :description "Access early beta features and experiments"
     :checked?    @(<s :feature-flag/beta-features?)
     :on-change   #(>e [:feature-flag/toggle-beta-features])}]
   [advanced-label "Advanced"]
   [flag-row-view
    {:flag-name   "Older features"
     :description "Bring back parts of Humble you used before (chats, AI sources, solutions)"
     :checked?    @(<s :auth/legacy?)
     :on-change   #(>e [:auth/toggle-legacy])}]
   (when @(<s :auth/admin?)
     [flag-row-view
      {:flag-name   "Features in progress"
       :description "Things we are still building. Expect rough edges."
       :checked?    @(<s :feature-flag/developer-features?)
       :on-change   #(>e [:feature-flag/toggle-developer-features])}])])
